import { COUNTRIES, getCountryCode } from "./countries";

function specializationKey(value) {
  if (!value) return "";
  return String(value).replace(/\s+/g, "").replace(/[()]/g, "");
}

export function translateSpecialization(value, t) {
  if (!value) return "—";
  const key = specializationKey(value);
  return t(`register:specializations.${key}`, { defaultValue: value });
}

export function translateNationality(value, t) {
  if (!value) return "—";
  const raw = String(value).trim();
  const code = getCountryCode(raw);
  if (code && code !== raw) {
    return t(`register:countries.${code}`, { defaultValue: raw });
  }
  const byCode = COUNTRIES.find((c) => c.code.toUpperCase() === raw.toUpperCase());
  if (byCode) {
    return t(`register:countries.${byCode.code}`, { defaultValue: byCode.name });
  }
  return raw;
}

export function translateRole(value, t) {
  if (!value) return "—";
  return t(`doctorProfile:roles.${value}`, { defaultValue: value });
}

export function formatFormCount(count, t) {
  const n = Number(count) || 0;
  if (n === 0 || n === 1) return `${n} ${t("filesPage:form")}`;
  return `${n} ${t("filesPage:formsPlural")}`;
}

/** Backend Patient.gender ENUM değerleri */
export const PATIENT_GENDER_VALUES = ["Male", "Female", "Other"];

/** Serbest metin / yerel dil girdisini API formatına çevirir */
export function normalizePatientGender(raw) {
  if (raw == null || String(raw).trim() === "") return "";
  const s = String(raw).trim();
  if (PATIENT_GENDER_VALUES.includes(s)) return s;
  const lower = s.toLowerCase();
  if (lower === "male" || lower === "erkek" || lower === "m") return "Male";
  if (lower === "female" || lower === "kadın" || lower === "kadin" || lower === "f") {
    return "Female";
  }
  if (lower === "other" || lower === "diğer" || lower === "diger" || lower === "o") {
    return "Other";
  }
  return "";
}

/** Görüntüleme: Male/Female/Other → çevrilmiş etiket */
export function translatePatientGender(value, t, { namespace = "patients" } = {}) {
  const normalized = normalizePatientGender(value);
  if (!normalized) return "";
  const key =
    normalized === "Male" ? "male" : normalized === "Female" ? "female" : "other";
  return t(`${namespace}:${key}`, { defaultValue: normalized });
}
